export const NOTIFICATIONS_REQUESTED = 'NOTIFICATIONS_REQUESTED'
export const NOTIFICATIONS_RECEIVED = 'NOTIFICATIONS_RECEIVED'
export const NOTIFICATIONS_SEEN_REQUESTED = 'NOTIFICATIONS_SEEN_REQUESTED'
export const NOTIFICATIONS_SEEN_RECEIVED = 'NOTIFICATIONS_SEEN_RECEIVED'
export const NOTIFICATIONS_CATEGORY_CHANGED = 'NOTIFICATIONS_CATEGORY_CHANGED'
export const UPDATE_EMERGENCY_CONTACT_REQUESTED =
  'UPDATE_EMERGENCY_CONTACT_REQUESTED'
export const UPDATE_EMERGENCY_CONTACT_RECEIVED =
  'UPDATE_EMERGENCY_CONTACT_RECEIVED'
export const UPDATE_MY_PHARMACY_REQUESTED = 'UPDATE_MY_PHARMACY_REQUESTED'
export const UPDATE_MY_PHARMACY_RECEIVED = 'UPDATE_MY_PHARMACY_RECEIVED'
export const SEARCH_PHARMACY_REQUESTED = 'SEARCH_PHARMACY_REQUESTED'
export const SEARCH_PHARMACY_RECEIVED = 'SEARCH_PHARMACY_RECEIVED'
export const APPOINTMENTS_REQUESTED = 'APPOINTMENTS_REQUESTED'
export const APPOINTMENTS_RECEIVED = 'APPOINTMENTS_RECEIVED'
export const CALL_ENDED_APPOINTMENTS_REQUESTED =
  'CALL_ENDED_APPOINTMENTS_REQUESTED'
export const CALL_ENDED_APPOINTMENTS_RECEIVED =
  'CALL_ENDED_APPOINTMENTS_RECEIVED'
export const DELETE_APPOINTMENT_REQUESTED = 'DELETE_APPOINTMENT_REQUESTED'
export const DELETE_APPOINTMENT_RECEIVED = 'DELETE_APPOINTMENT_RECEIVED'
export const TALK_TO_A_DOCTOR_NOW_REQUESTED = 'TALK_TO_A_DOCTOR_NOW_REQUESTED'
export const TALK_TO_A_DOCTOR_NOW_RECEIVED = 'TALK_TO_A_DOCTOR_NOW_RECEIVED'
export const APPOINTMENT_TIMESLOTS_REQUESTED = 'APPOINTMENT_TIMESLOTS_REQUESTED'
export const APPOINTMENT_TIMESLOTS_RECEIVED = 'APPOINTMENT_TIMESLOTS_RECEIVED'
export const TIMESLOT_SELECT_RECEIVED = 'TIMESLOT_SELECT_RECEIVED'
export const APPOINTMENTS_ETA_REQUESTED = 'APPOINTMENTS_ETA_REQUESTED'
export const APPOINTMENTS_ETA_RECEIVED = 'APPOINTMENTS_ETA_RECEIVED'
export const TIMESLOT_AVAILABILITY_CHECK_REQUESTED =
  'TIMESLOT_AVAILABILITY_CHECK_REQUESTED'
export const TIMESLOT_AVAILABILITY_CHECK_RECEIVED =
  'TIMESLOT_AVAILABILITY_CHECK_RECEIVED'
export const USER_PROFILE_REQUESTED = 'USER_PROFILE_REQUESTED'
export const USER_PROFILE_RECEIVED = 'USER_PROFILE_RECEIVED'
export const USER_PROFILE_EXTENDED_REQUESTED = 'USER_PROFILE_EXTENDED_REQUESTED'
export const USER_PROFILE_EXTENDED_RECEIVED = 'USER_PROFILE_EXTENDED_RECEIVED'
export const ACCOUNT_DATA_RECEIVED = 'ACCOUNT_DATA_RECEIVED'
export const WALLET_DATA_RECEIVED = 'WALLET_DATA_RECEIVED'
export const PROFILE_PICTURE_RECEIVED = 'PROFILE_PICTURE_RECEIVED'
export const PROFILE_PICTURE_REQUESTED = 'PROFILE_PICTURE_REQUESTED'
export const CLINICS_DATA_RECEIVED = 'CLINICS_DATA_RECEIVED'
export const LAST_LOCATION_RECEIVED = 'LAST_LOCATION_RECEIVED'
export const USER_PROFILE_PICTURE_CHANGE_REQUESTED =
  'USER_PROFILE_PICTURE_CHANGE_REQUESTED'
export const USER_PROFILE_PICTURE_CHANGE_RECEIVED =
  'USER_PROFILE_PICTURE_CHANGE_RECEIVED'
export const USER_PROFILE_PICTURE_CHANGE_FAILED =
  'USER_PROFILE_PICTURE_CHANGE_FAILED'
export const REPORT_TOKEN_REQUESTED = 'REPORT_TOKEN_REQUESTED'
export const REPORT_TOKEN_RECEIVED = 'REPORT_TOKEN_RECEIVED'
export const UPLOAD_FILE_REQUESTED = 'UPLOAD_FILE_REQUESTED'
export const UPLOAD_FILE_RECEIVED = 'UPLOAD_FILE_RECEIVED'
export const UPLOAD_INVOICE_FILE_REQUESTED = 'UPLOAD_INVOICE_FILE_REQUESTED'
export const UPLOAD_INVOICE_FILE_RECEIVED = 'UPLOAD_INVOICE_FILE_RECEIVED'
export const UPLOAD_PATIENT_ID_REQUESTED = 'UPLOAD_PATIENT_ID_REQUESTED'
export const UPLOAD_PATIENT_ID_RECEIVED = 'UPLOAD_PATIENT_ID_RECEIVED'
export const VALIDATE_COUNTRY_RECEIVED = 'VALIDATE_COUNTRY_RECEIVED'
export const VALIDATE_COUNTRY_REQUESTED = 'VALIDATE_COUNTRY_REQUESTED'
export const VALIDATE_STATE_RECEIVED = 'VALIDATE_STATE_RECEIVED'
export const VALIDATE_STATE_REQUESTED = 'VALIDATE_STATE_REQUESTED'
export const SUBSCRIPTION_VALIDATE_STATE_REQUESTED =
  'SUBSCRIPTION_VALIDATE_STATE_REQUESTED'
export const APPOINTMENT_TIMESLOTS_CANCELED = 'APPOINTMENT_TIMESLOTS_CANCELED'
export const TIMESLOT_AVAILABILITY_CHECK_CANCELED =
  'TIMESLOT_AVAILABILITY_CHECK_CANCELED'
export const APPOINTMENTS_POLL_REQUESTED = 'APPOINTMENTS_POLL_REQUESTED'
export const APPOINTMENTS_POLL_RECEIVED = 'APPOINTMENTS_POLL_RECEIVED'
export const APPOINTMENT_TIMEWINDOWS_REQUESTED =
  'APPOINTMENT_TIMEWINDOWS_REQUESTED'
export const CLEARED_APPOINTMENT_DESIGNATED_PK =
  'CLEARED_APPOINTMENT_DESIGNATED_PK'
export const APPOINTMENT_TIMEWINDOWS_RECEIVED =
  'APPOINTMENT_TIMEWINDOWS_RECEIVED'
export const APPOINTMENT_DESIGNATED_TIMEWINDOWS_RECEIVED =
  'APPOINTMENT_DESIGNATED_TIMEWINDOWS_RECEIVED'
export const INVITE_OTHER_FAMILY_MEMBER_IF_NEEDED =
  'INVITE_OTHER_FAMILY_MEMBER_IF_NEEDED'
export const CREATE_APPOINTMENT_RECEIVED = 'CREATE_APPOINTMENT_RECEIVED'
export const CREATE_APPOINTMENT_REQUESTED = 'CREATE_APPOINTMENT_REQUESTED'
export const CREATE_APPOINTMENT_FAILED = 'CREATE_APPOINTMENT_FAILED'
export const UPDATE_SEX_REQUESTED = 'UPDATE_SEX_REQUESTED'
export const UPDATE_SEX_RECEIVED = 'UPDATE_SEX_RECEIVED'
export const INVALIDATE_COUNTRY_RECEIVED = 'INVALIDATE_COUNTRY_RECEIVED'
export const CHECK_FOR_VALID_IP = 'CHECK_FOR_VALID_IP'
export const DOWNLOAD_LINK_REQUESTED_THROUGH_SMS_FAILURE =
  'DOWNLOAD_LINK_REQUESTED_THROUGH_SMS_FAILURE'
export const DOWNLOAD_LINK_REQUESTED_THROUGH_SMS_SUCCESS =
  'DOWNLOAD_LINK_REQUESTED_THROUGH_SMS_SUCCESS'
export const DOWNLOAD_LINK_REQUESTED_THROUGH_SMS =
  'DOWNLOAD_LINK_REQUESTED_THROUGH_SMS'
export const IS_IP_CHANGED_ON_RELOAD = 'IS_IP_CHANGED_ON_RELOAD'
export const INVALID_IP_RECIEVED = 'INVALID_IP_RECIEVED'

export const NOT_SERVICE_POPUP_SHOWED = 'NOT_SERVICE_POPUP_SHOWED'
export const NOT_SERVICE_POPUP_CLOSED = 'NOT_SERVICE_POPUP_CLOSED'
export const CANCEL_APPOINTMENT_REQUESTED = 'CANCEL_APPOINTMENT_REQUESTED'
export const CANCEL_APPOINTMENT_RECEIVED = 'CANCEL_APPOINTMENT_RECEIVED'
export const RESCHEDULE_APPOINTMENT_RECEIVED = 'RESCHEDULE_APPOINTMENT_RECEIVED'
export const RESCHEDULE_APPOINTMENT_REQUESTED =
  'RESCHEDULE_APPOINTMENT_REQUESTED'
export const SHOW_RESCHEDULE_APPOINTMENT = 'SHOW_RESCHEDULE_APPOINTMENT'
export const SHOW_CHOOSE_APPOINTMENT_MYSELF = 'SHOW_CHOOSE_APPOINTMENT_MYSELF'
export const SHOW_NOTIFICATIONS = 'SHOW_NOTIFICATIONS'
export const HIDE_NOTIFICATIONS = 'HIDE_NOTIFICATIONS'
export const INTERESTED_IN_CLINIC_REQUESTED = 'INTERESTED_IN_CLINIC_REQUESTED'
export const INTERESTED_IN_CLINIC_RECEIVED = 'INTERESTED_IN_CLINIC_RECEIVED'
export const HTN_FOLLOW_UP_USER_CANCEL = 'HTN_FOLLOW_UP_USER_CANCEL'
export const HTN_INITIAL_USER_CANCEL = 'HTN_INITIAL_USER_CANCEL'
export const HTN_INITIAL_USER_RESCHEDULE = 'HTN_INITIAL_USER_RESCHEDULE'

export const BLOCK_EARLIEST_STATUS_RECEIVED = 'BLOCK_EARLIEST_STATUS_RECEIVED'
export const MH_FOLLOW_UP_USER_CANCEL = 'MH_FOLLOW_UP_USER_CANCEL'
export const MH_INITIAL_USER_CANCEL = 'MH_INITIAL_USER_CANCEL'
export const MH_INITIAL_USER_RESCHEDULE = 'MH_INITIAL_USER_RESCHEDULE'
export const MH_FOLLOW_UP_USER_RESCHEDULE = 'MH_FOLLOW_UP_USER_RESCHEDULE'
export const TWILIO_TOKEN_REQUESTED = 'TWILIO_TOKEN_REQUESTED'
export const TWILIO_TOKEN_RECEIVED = 'TWILIO_TOKEN_RECEIVED'
export const ASK_NICELY_SLUG_REQUESTED = 'ASK_NICELY_SLUG_REQUESTED'
export const ASK_NICELY_SLUG_RECEIVED = 'ASK_NICELY_SLUG_RECEIVED'

export const CHOOSE_FAMILY_MEMBER = 'CHOOSE_FAMILY_MEMBER'
export const CHOOSE_OTHER_MEMBER = 'CHOOSE_OTHER_MEMBER'

export const UPDATE_GENDER_DETAILS_REQUESTED = 'UPDATE_GENDER_DETAILS_REQUESTED'
export const UPDATE_GENDER_DETAILS_RECEIVED = 'UPDATE_GENDER_DETAILS_RECEIVED'

export const UPDATE_CONTACT_INFORMATION_REQUESTED =
  'UPDATE_CONTACT_INFORMATION_REQUESTED'
export const UPDATE_CONTACT_INFORMATION_RECEIVED =
  'UPDATE_CONTACT_INFORMATION_RECEIVED'
export const UPDATE_CONTACT_INFORMATION_FAILED =
  'UPDATE_CONTACT_INFORMATION_FAILED'
export const UPDATE_CONTACT_INFORMATION_RESET_ERROR =
  'UPDATE_CONTACT_INFORMATION_RESET_ERROR'

export const PHONE_NUMBER_VERIFICATION_REQUESTED =
  'PHONE_NUMBER_VERIFICATION_REQUESTED'
export const PHONE_NUMBER_VERIFICATION_RECEIVED =
  'PHONE_NUMBER_VERIFICATION_RECEIVED'
export const PHONE_NUMBER_VERIFICATION_FAILED =
  'PHONE_NUMBER_VERIFICATION_FAILED'
export const PHONE_NUMBER_CODE_VERIFY_REQUESTED =
  'PHONE_NUMBER_CODE_VERIFY_REQUESTED'
export const PHONE_NUMBER_CODE_VERIFY_RECEIVED =
  'PHONE_NUMBER_CODE_VERIFY_RECEIVED'

export const SECRET_QUESTION_UPDATE_REQUESTED =
  'SECRET_QUESTION_UPDATE_REQUESTED'
export const SECRET_QUESTION_UPDATE_RECEIVED = 'SECRET_QUESTION_UPDATE_RECEIVED'
export const SECRET_QUESTION_UPDATE_FAILED = 'SECRET_QUESTION_UPDATE_FAILED'
export const UPDATE_LANGUAGE_REQUESTED = 'UPDATE_LANGUAGE_REQUESTED'
export const UPDATE_LANGUAGE_RECEIVED = 'UPDATE_LANGUAGE_RECEIVED'
export const UPDATE_LANGUAGE_FAILED = 'UPDATE_LANGUAGE_FAILED'

export const UPDATE_COMMUNICATION_PREFERENCES_REQUESTED =
  'UPDATE_COMMUNICATION_PREFERENCES_REQUESTED'
export const UPDATE_COMMUNICATION_PREFERENCES_RECEIVED =
  'UPDATE_COMMUNICATION_PREFERENCES_RECEIVED'
export const UPDATE_COMMUNICATION_PREFERENCES_FAILED =
  'UPDATE_COMMUNICATION_PREFERENCES_FAILED'

export const BENEFIT_FEATURE_FLAG_REQUESTED = 'BENEFIT_FEATURE_FLAG_REQUESTED'
export const BENEFIT_FEATURE_FLAG_RECEIVED = 'BENEFIT_FEATURE_FLAG_RECEIVED'

export const INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_PRESSED =
  'INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_PRESSED'
export const INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_REQUESTED =
  'INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_REQUESTED'
export const INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_RECEIVED =
  'INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_RECEIVED'
export const INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_FAILED =
  'INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_FAILED'

export const HMO_CONSENT_AGREEMENT_REQUESTED = 'HMO_CONSENT_AGREEMENT_REQUESTED'
export const HMO_CONSENT_AGREEMENT_RECEIVED = 'HMO_CONSENT_AGREEMENT_RECEIVED'

export const APP_CONFIG_REQUESTED = 'APP_CONFIG_REQUESTED'
export const APP_CONFIG_RECEIVED = 'APP_CONFIG_RECEIVED'

export const CONFIG_VIDEO_PRIVDER_REQUESTED = 'CONFIG_VIDEO_PRIVDER_REQUESTED'
export const CONFIG_VIDEO_PRIVDER_RECEIVED = 'CONFIG_VIDEO_PRIVDER_RECEIVED'

export const DELAYED_ACTION_REQUESTED = 'DELAYED_ACTION_REQUESTED'
